import React, { Component } from "react";
import { translate } from "../../../utils/useful";
import DropHandles from "./DropHandlers";
import RowContent from "./RowContent";
import SingleRow from "./SingleRow";
import ToolBox from "./ToolBox";

class FormsContainer extends Component {
    state = {
        displayHandlers: false
    };

    // showDropZone = () => {
    //     this.setState({ displayHandlers: true })
    // }

    render() {
        const {
            pageContent,
            showhandlers,
            showhandlersFunc,
            hideHandlersFunc,
            addnewItem,
            changeInputPosition,
            deleteInput,
            openInputConfig
        } = this.props;

        return (
            <div className={"form-column forms h-100 pt-2 pb-3 " + (this.props.isInput ? "px-2" : 'px-4')}>
                {pageContent?.map((section, sectionIndex) => {

                    let formsRows = section.sectionContent
                    let sectionId = section.sectionId
                    // console.log('seccccction', section)
                    return (
                        <div className="form-section">
                            {/* {console.log('tes=============================t', formsRows)} */}

                            {formsRows.map((row, rowIndex) => {
                                const { rowId, rowContent } = row;
                                // 
                                let rowLength = rowContent.length;

                                return (
                                    <SingleRow
                                        key={rowIndex}
                                        inputClass={this.props.inputClass}
                                        formClass={this.props.formClass}
                                        rowContent={rowContent}
                                        rowId={rowId}
                                        pageIndex={this.props.pageIndex}
                                        pageId={this.props.pageId}
                                        setFormData={this.props.setFormData}
                                        sectionIndex={sectionIndex}
                                        sectionId={sectionId}
                                        formsRows={formsRows}
                                        showhandlers={showhandlers}
                                        showhandlersFunc={showhandlersFunc}
                                        hideHandlersFunc={hideHandlersFunc}
                                        rowLength={rowLength}
                                        rowIndex={rowIndex}
                                        addnewItem={addnewItem}
                                        openInputConfig={openInputConfig}
                                        changeInputPosition={changeInputPosition}
                                        deleteInput={deleteInput}
                                        displayHandlers={this.state.displayHandlers}
                                        setDisplayHandlers={() => this.setState({ displayHandlers: true })}
                                    />
                                );
                            })}

                        </div>
                    )
                })}
            </div>
        );
    }
}

export default FormsContainer;
